import { Injectable, NgModule, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';

@Injectable()

@NgModule({
  imports: [MatDialogModule, BrowserAnimationsModule, FormsModule]
})

export class ReportService {
  myAppUrl: string = "";
  ForExportUrl: string = "";

  constructor(private _http: Http, @Inject('BASE_URL') baseUrl: string) {
    this.ForExportUrl = 'https://jqwidgets.com/export_server/dataexport.php';
    //this.ForExportUrl = baseUrl + 'dataexport.php';
  }

  //print pdf
  showPrint(myGrid, Name) {
    let gridContent = myGrid.exportdata('html');
    let newWindow = window.open('', '', 'width=800, height=500'),
      document = newWindow.document.open(),
      pageContent =
        '<!DOCTYPE html>\n' +
        '<html>\n' +
        '<head>\n' +
        '<meta charset="utf-8" />\n' +
        '<title>' + Name + '</title>\n' +
        '</head>\n' +
        '<body>\n' + gridContent + '\n</body>\n</html>';
    document.write(pageContent);
    document.close();
    newWindow.print();
  };

  //export excel
  exportExcel(myGrid, Name) {
    //let data = new FormData();
    //data.append('upfile', myGrid.jqxGrid('exportdata', 'xls'), Name);

    //return this._http.post(this.myAppUrl + 'api/report/ExportExcel', data, {
    //  headers: new Headers({
    //    "Authorization": "Bearer " + localStorage.getItem("jwt"),
    //    "Content-Type": "application/json; charset=utf-8"
    //  })
    //})
    //  .map((response: Response) => response.json())
    //  .catch(this.errorHandler);
    myGrid.exportdata('xls', Name, true, null, true, this.ForExportUrl);
  };

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }
}  



// WEBPACK FOOTER //
// ./src/app/services/report-service.ts